import type { RefObject } from 'react';
import {
  createRowSelectionManager,
  gridExpandedSortedRowIdsSelector,
  type GridApi,
  type GridRowId,
  type GridRowSelectionModel
} from '@mui/x-data-grid';

// MUI X v8+ represents row selection as `{ type, ids: Set }` instead of an array of ids.
// These helpers let components keep array-based selection state.

export const toRowSelectionModel = (ids: readonly GridRowId[]): GridRowSelectionModel => ({
  type: 'include',
  ids: new Set(ids)
});

// An 'exclude' model (e.g. from the "select all" checkbox) means every visible row except `ids`.
export const getSelectedRowIds = (
  model: GridRowSelectionModel,
  apiRef: RefObject<GridApi | null>
): GridRowId[] => {
  if (model.type === 'include') {
    return [...model.ids];
  }
  const selectionManager = createRowSelectionManager(model);
  return gridExpandedSortedRowIdsSelector(apiRef).filter((id) => selectionManager.has(id));
};
